module.exports = __webpack_public_path__ + "static/media/loader-white.77c2dd3d.mp4";